import constants from "../../../../../appConstants";
import {
  MultiSelectFilter,
  DateTimeFilter,
} from "../../../../dataGrid/columnFilters";
import { TimeRangeEditor, NumericEditor } from "../../../../dataGrid/cellEditors";

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration({ featureFlags }) {
    return GridConfig.getDefaultConfiguration(featureFlags);
  }
  static CommandCellRenderer(props) {
    return (
      <div
       className="ShipperName"
      >
        <b>{props.data.shipperName}</b>
        <br></br>
        {props.data.shipperAddress}
        <br></br>
        {props.data.shipperCity}, {props.data.shipperState}{" "}
        {props.data.shipperZip}
      </div>
    );
  }
  static pickupWindowValueGetter(rowNode) {
    return `${rowNode.data.pickupReadyTime} - ${rowNode.data.pickupCloseTime}`;
  }

  static pickupWindowValueSetter(rowNode) {
    if (rowNode.newValue === rowNode.oldValue) {
      return false;
    }
    const [startTime, endTime] =
      rowNode.newValue && rowNode.newValue.split("-");
    rowNode.data["pickupReadyTime"] = startTime;
    rowNode.data["pickupCloseTime"] = endTime;
    return true;
  }
  static isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    return displayedColumns[0] === params.column;
  }
  static getDefaultConfiguration(featureFlags) {
    return {
      title: "Pickups for Optimization",
      rowSelection: "multiple",
      rowDeselection: true,
      defaultColDef: {
        lockPinned: true,
        sortable: true,
        filter: true,
        resizable: true,
        headerCheckboxSelection: GridConfig.isFirstColumn,
        checkboxSelection: GridConfig.isFirstColumn,
      },
      columns: [
        {
          headerName: "Pickup Name",
          headerTooltip: "Pickup Name",
          minWidth: constants.columnWidth.OPTIMIZATION_PICKUP_NAME,
          headerClass: "headerCellStyle",
          cellClass: "pickupNameCellClass",
          lockPosition: true,
          field: "shipperName",
          cellRendererFramework: GridConfig.CommandCellRenderer,
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Pickup Window",
          headerTooltip: "Pickup Window",
          field: "pickupWindow",
          minWidth: constants.columnWidth.OPTIMIZATION_DELIVERY_WINDOW,
          cellClass: "gridCell-leftAlign",
          valueGetter: GridConfig.pickupWindowValueGetter,
          valueSetter: GridConfig.pickupWindowValueSetter,
          filterFramework: DateTimeFilter,
          filterParams: {
            DATETYPE: constants.DATETYPES.TIME,
            isFullRangeFilter: true,
          },
          editable: true,
          cellEditorFramework: TimeRangeEditor,
          suppressKeyboardEvent: (params) => params.editing,
          lockPosition: true,
        },
        {
          headerName: "PSE",
          field: "pse",
          headerTooltip: "PSE",
          minWidth: constants.columnWidth.OPTIMIZATION_PSE,
          cellClass: "gridCell-leftAlign",
          editable: true,
          lockPosition: true,
          filterFramework: MultiSelectFilter,
          cellEditorFramework: NumericEditor,
          hide: featureFlags.IsWeightBasedRoutingEnabled,
        },
      ],
    };
  }
}
